import React, { Fragment, useEffect, useState } from 'react'
// import { copyToClipboard } from 'functions/copy/copyToClipboard'
import { ProvSeedPair } from './interface'
import { SeedBox, Wrapper } from '../ProvablyStyle'
import { copyToClipboard } from '../../../helpers/copyToClipboard'
import Notify from './Notify'
import { useNotification } from '@orbital/games-frontend-library'

export default function ProvablySeedPair({
  pf,
  background,
  size,
  color,
  height,
  padding,
  marginBottom,
}: ProvSeedPair) {
  const [notification, handleNotification, notificationfadeOut] =
    useNotification()

  const [isTarget, setisTarget] = useState<boolean>(false)
  return (
    <Fragment>
      {pf.map((item: any, id: any) => (
        <div key={id}>
          <SeedBox
            copyCursor={item.enableCopy}
            height={
              !height && (item.content === '-' || item.content.length < 45)
                ? '14px'
                : height
            }
            background={background}
            size={size}
            color={color}
            padding={padding}
            marginBottom={marginBottom}
          >
            <p>{item.title}</p>
            <textarea
              onClick={e =>
                item.enableCopy &&
                copyToClipboard(e, setisTarget, handleNotification)
              }
              value={item.content}
              spellCheck='false'
              readOnly
              className={item.title === 'Nonce' ? 'nonce' : ''}
            />
          </SeedBox>
          <Wrapper>
            {!!notification && isTarget == item.content && (
              <Notify text={notification} fadeOut={notificationfadeOut} />
            )}
          </Wrapper>
        </div>
      ))}
    </Fragment>
  )
}
